import ApiClient from "@common/api/ApiClient";

/**
 * Class representing a client for review.
 * Extends the ApiClient to provide specific functionalities for API requests.
 *
 * @extends ApiClient
 */
class ReviewClient extends ApiClient {
  /**
   * Create a ReviewClient.
   * Initializes the API client with the "Review" route and sets the API URL key.
   */
  constructor() {
    super("Review");
    this.setApiUrlKey("comp_api_url");
  }

  Search = async (payload) => await this.post("Search", payload);

  SearchMetadata = async (payload) => await this.get("Search");

  UpdateMetadata = async (reviewId) =>
    await this.get(
      `Update?id=${reviewId}&includeImages=false&includeThumbnails=false`,
    );

  Read = async (reviewId) =>
    await this.get(
      `Read?id=${reviewId}&includeImages=false&includeThumbnails=false`,
    );

  Update = async ({ customerId, id = null, form }) => {
    await this.post(`Update`, {
      id,
      customerId,
      ...form,
    });
  };

  // GET Create - get questions and metadata for new review
  Create = async () => {
    return await this.get(`Create`);
  };

  // POST Create - create a review and get review id
  CreateReview = async (payload) => {
    return await this.post(`Create`, payload);
  };

  Complete = async (payload) => {
    return await this.post(`Complete`, payload);
  };

  /** GET Review/Assignees — users eligible for @mentions in review comments */
  Assignees = async () => await this.get("Assignees");
}

const client = new ReviewClient();

export default client;
